module.exports = __webpack_public_path__ + "portal/assets/img/logo.c02ca345.svg";